<div style="margin-top:0px;">

    <div fxLayoutAlign.gt-sm="end center center" fxLayoutAlign.lt-md="center stretch" fxFlex.lt-md="100">
        <button ngStyle.lt-md="width:100%;"
                style="background: var(--primary); color:white; font-weight: normal; vertical-align: middle;"
                mat-flat-button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger">
            Ενέργειες
            &nbsp;
            <mat-icon style="vertical-align: middle; color:white;">
                {{menuTrigger.menuOpen ? 'expand_less' : 'expand_more'}}
            </mat-icon>
        </button>

        <mat-menu #menu="matMenu">
            <mat-list>
                <mat-list-item class="menuList" >
                    <button mat-menu-item (click)="exportToExcel()">
                        <mat-icon class="icon">description</mat-icon> &nbsp;Εξαγωγή σε xlsx
                    </button>
                </mat-list-item>
                <mat-list-item class="menuList" >
                    <button mat-menu-item (click)="exportToPDF()">
                        <mat-icon class="icon">picture_as_pdf</mat-icon> &nbsp;Εξαγωγή σε pdf
                    </button>
                </mat-list-item>
                <mat-list-item class="menuList" >
                    <button mat-menu-item disabled="true" (click)="sendExcelToEmail()">
                        <mat-icon class="icon">clear</mat-icon>&nbsp;Προσθήκη xlsx σε email
                    </button>
                </mat-list-item>
                <mat-list-item class="menuList" >
                    <button mat-menu-item (click)="sendPDFToEmail()">
                        <mat-icon class="icon">email</mat-icon>&nbsp;Προσθήκη pdf σε email
                    </button>
                </mat-list-item>
            </mat-list>
        </mat-menu>
    </div>


    <div #tableContainer>
        <table mat-table [dataSource]="displayEnrollments" matSort class="mat-elevation-z0">
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef> Α/Α </th>
                <td mat-cell *matCellDef="let element"> {{element.id}} </td>
            </ng-container>
            <ng-container matColumnDef="childDisplayName">
                <th mat-header-cell *matHeaderCellDef> Ονοματεπώνυμο χρήστη </th>
                <td mat-cell *matCellDef="let element"> {{element.childDisplayName}} </td>
            </ng-container>

            <ng-container matColumnDef="className">
                <th mat-header-cell *matHeaderCellDef> Κατηγορία </th>
                <td mat-cell *matCellDef="let element"> {{element.className}} </td>
            </ng-container>

            <ng-container matColumnDef="level_description">
                <th mat-header-cell *matHeaderCellDef> Επίπεδο </th>
                <td mat-cell *matCellDef="let element"> {{element.level_description}} </td>
            </ng-container>

            <ng-container matColumnDef="fatherDisplayName">
                <th mat-header-cell *matHeaderCellDef> Στοιχεία επικοινωνίας 1 </th>
                <td mat-cell *matCellDef="let element"> {{element.fatherDisplayName}} </td>
            </ng-container>

            <ng-container matColumnDef="motherDisplayName">
                <th mat-header-cell *matHeaderCellDef> Στοιχεία επικοινωνίας 2 </th>
                <td mat-cell *matCellDef="let element"> {{element.motherDisplayName}} </td>
            </ng-container>

            <ng-container matColumnDef="enroll_date">
                <th mat-header-cell *matHeaderCellDef> Ημερομηνία εγγραφής </th>
                <td mat-cell *matCellDef="let element"> {{element.enroll_date}} </td>
            </ng-container>



            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
<!--    <div fxLayout="row" fxLayoutAlign="center center center">-->
<!--        <mat-paginator [length]="resultLength" [pageSize]="5" [pageSizeOptions]="[20, 50, 100]">-->
<!--        </mat-paginator>-->
<!--    </div>-->
</div>
